import { useState } from "react";
import { Link, useHistory } from "react-router-dom";

function Header({ currentBlock }) {
  const [searchValue, setSearchValue] = useState("");
  const history = useHistory();

  const handleSearch = (e) => {
    e.preventDefault();
    const value = searchValue.trim();

    if (!value) return;

    if (/^\d+$/.test(value)) {
      history.push(`/block/${value}`);
    } else if (/^0x[a-fA-F0-9]{64}$/.test(value)) {
      history.push(`/tx/${value}`);
    } else if (/^0x[a-fA-F0-9]{40}$/.test(value)) {
      history.push(`/address/${value}`);
    } else {
      alert("Invalid input. Enter a block number, transaction hash, or address.");
    }

    setSearchValue("");
  };

  return (
    <header className="header">
      <div className="header-content">
        <Link to="/" className="logo">
          BLOCK EXPLORER
        </Link>
        {currentBlock && (
          <div className="current-block">
            Latest Block: <Link to={`/block/${currentBlock}`}>{currentBlock}</Link>
          </div>
        )}
      </div>
      <form onSubmit={handleSearch} className="search-bar">
        <input
          type="text"
          placeholder="Search by Block / Transaction / Address"
          value={searchValue}
          onChange={(e) => setSearchValue(e.target.value)}
          className="search-input"
        />
        <button type="submit" className="search-button">
          SEARCH
        </button>
      </form>
    </header>
  );
}

export default Header;
